module.exports = __webpack_public_path__ + "static/device-screens-eefc8286f1f2d0556ba2691a56873c3d.png";